var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImagePreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33 39.5H7C3.40983 39.5 0.5 36.5902 0.5 33V7C0.5 3.40983 3.40983 0.5 7 0.5H33C36.5902 0.5 39.5 3.40983 39.5 7V33C39.5 36.5902 36.5902 39.5 33 39.5Z",
    fill: "#B0B7C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6396 10.2768C17.1204 11.7576 17.1204 14.1583 15.6396 15.639C14.1589 17.1198 11.7581 17.1198 10.2774 15.639C8.79669 14.1583 8.79669 11.7575 10.2774 10.2768C11.7582 8.79608 14.1589 8.79608 15.6396 10.2768",
    stroke: "white",
    strokeWidth: 3.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5002 15.9024C38.5252 15.7638 37.535 15.6663 36.521 15.6663C25.003 15.6663 15.6669 25.0024 15.6669 36.5204C15.6669 37.5344 15.7644 38.5246 15.903 39.4996",
    stroke: "white",
    strokeWidth: 3.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePreview);
export default __webpack_public_path__ + "static/media/image-preview.1643424c66df6d5504cb08f25e108be1.svg";
export { ForwardRef as ReactComponent };